import {
  useDispatch,
  useSelector,
  type TypedUseSelectorHook,
} from 'react-redux'
import type { AppDispatch, RootState } from './types'

export type { AppDispatch, RootState }

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

/** Aliases for components migrated from `src/store`. */
export { useAppDispatch as useDispatch, useAppSelector as useSelector }
